import React from "react";
import { FormLayout } from "playground/cms/Form";
import Resources from "playground/cms/views/Resources";
import FlatsForm from "./FlatsForm";
//import PropTypes from 'prop-types';

export function Flats(props) {
    const { isDraft } = props;
    const url = "apartments/flats?order=building,code asc";
    return (
        <Resources {...props} url={url}>
            <FormLayout>
                <FormLayout.Content replace={true}>
                    <FormLayout.Tab id={"flat"} label={"Mieszkanie"}>
                        <FlatsForm {...props} />
                    </FormLayout.Tab>
                </FormLayout.Content>
            </FormLayout>
        </Resources>
    );
}

Flats.propTypes = {};

Flats.defaultProps = {};

export default Flats;
